import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

export const DecisionAnalysisPage: React.FC = () => {
  const navigate = useNavigate()
  
  // Redirect to pros & cons analysis page with a slight delay for better UX
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/decision-analysis/pros-cons', { replace: true })
    }, 100)
    
    return () => clearTimeout(timer)
  }, [navigate])
  
  return (
    <>
      <Helmet>
        <title>AI Decision Analysis - AI Decision Maker | Free Online Decision Assistant</title>
        <meta name="description" content="Start your AI decision analysis journey. Choose from pros & cons analysis, causal chain analysis, context analysis, or multi-option analysis. Free online decision assistant." />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://aidecision.org/decision-analysis/pros-cons" />
        <meta httpEquiv="refresh" content="0;url=/decision-analysis/pros-cons" />
      </Helmet>
      <div className="text-center py-8">
        <div className="max-w-md mx-auto">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">AI Decision Analysis</h1>
          <p className="text-gray-600 mb-4">Redirecting you to the best decision analysis tool...</p>
          <div className="animate-pulse">
            <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto"></div>
          </div>
          <p className="text-sm text-gray-500 mt-4">
            If you're not redirected automatically, 
            <a href="/decision-analysis/pros-cons" className="text-blue-600 hover:underline ml-1">
              click here
            </a>
          </p>
        </div>
      </div>
    </>
  )
} 